import React from "react";
import styled, { keyframes } from "styled-components";
import { Heading } from "../";

const appearOnLeft = keyframes`
  0% {
    transform: translateX(-1000px);
    opacity: 0;
  }
  60% {
    opacity: 1;
  }
  100% {
    transform: translateX(0);
  }
`;

const StyledHeadingWithBackground = styled.div`
  display: flex;
  position: relative;
`;

const Background = styled.div`
  position: absolute;
  width: 100%;
  height: 50%;
  bottom: -10%;
  left: -10%;
  background: #282831;
  z-index: -1;
  animation-name: ${appearOnLeft};
  animation-duration: 0.5s;
`;

export const HeadingWithBackground = ({ as = "h1", ...props }) => {
  return (
    <StyledHeadingWithBackground>
      <Heading as={as} {...props}>
        {props.children}
      </Heading>
      <Background />
    </StyledHeadingWithBackground>
  );
};
